import { Dispatch } from 'react';
import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import {
  CampaignCategoryItem,
  CampaignCategoryListParam,
  CampaignCategoryUpdateItem,
} from '../types/campaign-category';
import { PaginateList } from 'src/app/common/types/common-types';
import { forEach } from 'lodash';

export const fetchCampaignCategoryItem = async (
  id: string,
  dispatch?: Dispatch<any>,
): Promise<CampaignCategoryItem> => {
  return apiClient
    .get<CampaignCategoryItem>(`${ADMIN_URL}/v2/campaign-category/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const createCampaignCategory = async (data: CampaignCategoryItem, dispatch?: Dispatch<any>): Promise<string> => {
  return apiClient
    .post<string>(`${ADMIN_URL}/v2/campaign-category`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const modifyCampaignCategory = async (
  id: string,
  data: CampaignCategoryUpdateItem,
  dispatch?: Dispatch<any>,
): Promise<string> => {
  return apiClient
    .patch<string>(`${ADMIN_URL}/v2/campaign-category/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const fetchCampaignCategoryList = async (
  params: CampaignCategoryListParam,
  dispatch?: Dispatch<any>,
): Promise<PaginateList<CampaignCategoryItem>> => {
  let queryPath = `${ADMIN_URL}/v2/campaign-category/list?`;
  forEach(params, (param, key) => {
    queryPath += param ? `${key}=${encodeURIComponent(param as any)}&` : '';
  });

  return apiClient
    .get<PaginateList<CampaignCategoryItem>>(queryPath)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};

export const deleteCampaignCategory = async (id: string, dispatch?: Dispatch<any>): Promise<void> => {
  return apiClient
    .delete<void>(`${ADMIN_URL}/v2/campaign-category/${id}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw apiErrorHandler(err, dispatch);
    });
};
